import { memo, useEffect } from 'react';
import { Layout as LayoutView } from 'modules/application/components/Layout';
import { Editor } from 'modules/editor/containers/Editor';
import WifiBottomPanelResponsive from 'modules/bottomPanel/containers/WifiBottomPanelResponsive';
import CustomClientForm from 'modules/devices/containers/CustomClientForm';
import { useDispatch } from 'app/store';
import { FeatureTourLazy } from 'components/FeatureTour/FeatureTourLazy';
import { applicationInit } from '../actions';

function LayoutImpl() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(applicationInit());
  }, [dispatch]);

  return (
    <LayoutView>
      <Editor />
      <WifiBottomPanelResponsive />
      <CustomClientForm />
      <FeatureTourLazy />
    </LayoutView>
  );
}

export const Layout = memo(LayoutImpl);
